module.exports = __webpack_public_path__ + "static/media/filetype-xls.d80635dc.svg";